import { render, staticRenderFns } from "./TaskPhotosBlock.vue?vue&type=template&id=1652c9a8&scoped=true"
import script from "./TaskPhotosBlock.vue?vue&type=script&lang=js"
export * from "./TaskPhotosBlock.vue?vue&type=script&lang=js"
import style0 from "./TaskPhotosBlock.vue?vue&type=style&index=0&id=1652c9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652c9a8",
  null
  
)

export default component.exports